// extracted by mini-css-extract-plugin
export default {"Slide":"GalleryItem_Slide__XSCoD"};